export const iconFontAwesomeMedicalHealthUserNurse = (
	<i className="fa-solid fa-user-nurse"></i>
);
